import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { RequestForm } from "@/lib/types";

/**
 * "Anfrage stellen" picker: submission-enabled ticket boards in OTHER
 * departments (workspaces the user is NOT in) — you raise requests to other
 * teams, not your own. The backend (`/me/request-forms`) owns that rule and is
 * intentionally cross-workspace (submission never requires membership).
 */
export function useSubmitTargets() {
  return useQuery<RequestForm[]>({
    queryKey: ["me", "request-forms"],
    queryFn: () => api.listRequestForms(),
    staleTime: 60_000,
  });
}
